import React from 'react';
import AppRouter from './Router';
import store from './redux/store';
import { Provider } from 'react-redux';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import { StylesProvider } from '@mui/styles';

const theme = createTheme({
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          '& .MuiTab-wrapper': {
            textTransform: 'none',
          },
        },
      },
    },
  },
});

export default function App() {
  return (
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <StylesProvider injectFirst>
            <AppRouter />
          </StylesProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </Provider>
  );
}
